const MS_IN_DAY = 1000 * 60 * 60 * 24;

export const formatarMoedaBR = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valor);
};

export const formatarPrecoPorMensagem = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 3,
  }).format(valor);
};

export const formatarDataCurta = (dataISO: string): string => {
  if (!dataISO) return '—';
  return new Date(dataISO).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const formatarDataHora = (dataISO: string): string => {
  if (!dataISO) return '—';
  return new Date(dataISO).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatarPeriodoCiclo = (inicioISO: string, fimISO: string): string => {
  return `${formatarDataCurta(inicioISO)} — ${formatarDataCurta(fimISO)}`;
};

export const calcularDiasRestantesCiclo = (fimISO: string): number => {
  const fim = new Date(fimISO).getTime();
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.ceil((fim - hoje.getTime()) / MS_IN_DAY);
};

export const formatarDiasRestantes = (dias: number): string => {
  if (dias > 1) return `${dias} dias para fechar`;
  if (dias === 1) return '1 dia para fechar';
  if (dias === 0) return 'Fecha hoje';
  if (dias === -1) return 'Atrasado em 1 dia';
  return `Atrasado em ${Math.abs(dias)} dias`;
};

export const formatarPercentual = (valor: number): string => {
  return `${Math.round(valor)}%`;
};
